import React from 'react';
import { Modal } from 'react-bootstrap';

function SizeGuide(props) {
	return (
		<Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
			<Modal.Header closeButton>
				<Modal.Title id="contained-modal-title-vcenter">The RayRue Size Guide</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<p>
					We know how frustrating it can be to order the wrong size so here in our size guide we have put
					together all the information you will need to help you choose. Please note that throughout all our
					sizing charts for women, men and girls, the measurements you will see are based on actual body
					measurements, not garment measurements.
				</p>
			</Modal.Body>
			<Modal.Footer>
				<button onClick={props.onHide}>Close</button>
			</Modal.Footer>
		</Modal>
	);
}

export default SizeGuide;
